// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#sidebar-nav-items::-webkit-scrollbar {\n  display: none !important;\n}\n", "",{"version":3,"sources":["webpack://./src/components/SidebarNav/scrollbar.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B","sourcesContent":["#sidebar-nav-items::-webkit-scrollbar {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
